<pagination [listId]="listId"></pagination>
<div class="items">
  <phonebook-list-item [member]="member" *ngFor="let member of items"></phonebook-list-item>
</div>
<pagination [listId]="listId"></pagination>
